import React          from 'react';
import { words }      from '../utils/dictionary'
import colors         from '../utils/colors'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
       width:           '100%',
       height:          '100%',
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       textAlign:       'center',
     //  fontSize:        23,
       color:           '#FFF'
    }
}))

type pageSelectorProps = {
    size:            number[];
    ind:             number;
    page:            string;
    val:             string;
    lang:            string;
    showSmallNavBar: boolean;
    handleClick:     (val: string) => void;
}
const PageSelector: React.FC<pageSelectorProps> = ({ 
  size, 
  ind, 
  page, 
  val, 
  lang, 
  showSmallNavBar, 
  handleClick 
}) => {

  const classes = useStyles();

  const [hover, setHover]           = React.useState('')
  const [initialPos, setInitialPos] = React.useState(false)

  const disable = React.useMemo(() => {
      return page === val
  },[page, val])

  
  React.useEffect(() => {
    setTimeout(() => {
      setInitialPos(true)
    }, (ind + 1) * 100)
  },[ind])


  return (
    <div 
       className      = { classes.root }
       dir            = 'rtl'
       onClick        = { () => { if (!disable) { handleClick(val) }}}
       onMouseEnter   = { () => { if (!disable) { setHover(val) }}}
       onMouseLeave   = { () => { setHover('') }}
        style         = {{
          color:      disable ? colors.blue : hover === val ? '#BCF' : showSmallNavBar ? colors.dark : '#FFF',
          cursor:     disable ? 'default' : 'pointer',
          fontSize:   size[0] > 600 && size[0] <= 900 ? 20 : 23,
          transform:  `translate(0%, ${ initialPos ? 0 : 100 }vh)`,
          transition: `transform ${ showSmallNavBar ? '0' : '1'}s`
        }}
    >
         { words[`${ val }`][lang] }
    </div>
  );
}




export default PageSelector;

